export const ROLE_HIERARCHY = {
  "vf-admin": 6,
  "vf-viewer": 6,
  "vf-editor": 6,
  superadmin: 5,
  admin: 4,
  editor: 3,
  commentor: 2,
  viewer: 1,
};

export const VF_ROLES = ["vf-admin", "vf-viewer", "vf-editor"];

// Dynamic CSS for edit user drawer
export const EDIT_USER_PERMISSION_LIST_HEIGHTS = {
  0: "h-[calc(100dvh-490px)]",
  1: "h-[calc(100dvh-500px)]",
  2: "h-[calc(100dvh-535px)]",
  3: "h-[calc(100dvh-565px)]",
  4: "h-[calc(100dvh-605px)]",
};

export const EDIT_USER_DETAILS_HEIGHTS = {
  0: "h-[calc(100dvh-350px)]",
  1: "h-[calc(100dvh-360px)]",
  2: "h-[calc(100dvh-375px)]",
  3: "h-[calc(100dvh-400px)]",
  4: "h-[calc(100dvh-425px)]",
};

export const EDIT_USER_ASSIGN_ROLE_HEIGHTS = {
  0: "h-[calc(100dvh-290px)]",
  1: "h-[calc(100dvh-300px)]",
  2: "h-[calc(100dvh-320px)]",
  3: "h-[calc(100dvh-340px)]",
  4: "h-[calc(100dvh-370px)]",
};

export const EDIT_USER_ORGANIZATION_LIST_HEIGHTS = {
  0: "h-[calc(100dvh-430px)]",
  1: "h-[calc(100dvh-440px)]",
  2: "h-[calc(100dvh-460px)]",
  3: "h-[calc(100dvh-480px)]",
  4: "h-[calc(100dvh-505px)]",
};

export const EDIT_USER_AGENT_DETAILS_HEIGHTS = {
  0: "h-[calc(100dvh-352px)]",
  1: "h-[calc(100dvh-360px)]",
  2: "h-[calc(100dvh-380px)]",
  3: "h-[calc(100dvh-400px)]",
  4: "h-[calc(100dvh-425px)]",
};

// Dynamic CSS for view user drawer
export const VIEW_USER_USER_DETAILS_HEIGHTS = {
  0: "h-[calc(100dvh-218px)]",
  1: "h-[calc(100dvh-220px)]",
  2: "h-[calc(100dvh-235px)]",
  3: "h-[calc(100dvh-250px)]",
  4: "h-[calc(100dvh-265px)]",
};

// Dynamic CSS for create user drawer
export const CREATE_USER_SELECT_ORGANIZATION = (
  errorLength: number,
  fontSize: number
): string => {
  const errorHeights = {
    0: 10,
    1: 10,
    2: 10,
    3: 14,
    4: 14,
  };

  const errorHeight =
    errorLength > 1
      ? errorHeights[errorLength as keyof typeof errorHeights] * errorLength
      : 0;

  const baseHeights =
    errorLength > 0
      ? {
          0: 575,
          1: 600,
          2: 627,
          3: 660,
          4: 700,
        }
      : {
          0: 568,
          1: 590,
          2: 615,
          3: 643,
          4: 675,
        };

  const baseHeight =
    baseHeights[fontSize as keyof typeof baseHeights] || baseHeights[0];
  const totalHeight = baseHeight + errorHeight;

  return `calc(100dvh - ${totalHeight}px)`;
};

export const CREATE_USER_AGENT_DETAILS_HEIGHTS = {
  0: "h-[calc(100dvh-185px)]",
  1: "h-[calc(100dvh-190px)]",
  2: "h-[calc(100dvh-200px)]",
  3: "h-[calc(100dvh-215px)]",
  4: "h-[calc(100dvh-225px)]",
};

export const CREATE_USER_ASSIGN_ROLE_HEIGHTS = {
  0: "max-h-[calc(100dvh-220px)]",
  1: "max-h-[calc(100dvh-228px)]",
  2: "max-h-[calc(100dvh-245px)]",
  3: "max-h-[calc(100dvh-265px)]",
  4: "max-h-[calc(100dvh-285px)]",
};

// Dynamic CSS for csv preview
export const CSV_PREVIEW_HEIGHTS = {
  0: "h-[calc(100dvh-315px)]",
  1: "h-[calc(100dvh-320px)]",
  2: "h-[calc(100dvh-330px)]",
  3: "h-[calc(100dvh-345px)]",
  4: "h-[calc(100dvh-355px)]",
};
